<template>
  <div>
    <Header/>
    <div class="container">
      <a href="#" @click.prevent="$router.go(-1)" class="flex-v-center md-hidden">
        <svg class="rotate-180 mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
        </svg>
        {{ $lang.messages.back }}
      </a>
      <div class="device-wrapper">
        <div class="account-settings text-uppercase mt-1 mb-3 text-xl text-bold">
          <span class="account-settings-avatar mr-1"></span>
          {{ $lang.messages.account.settings }}
        </div>
        <div class="content-block-item device-setting">
          <div class="device-setting-icon -highlight">
            <img src="../assets/img/account-image.svg" alt="account">
          </div>
          <div class="device-setting-content">
            <div class="device-setting-title mb-1">{{ $lang.messages.account.info }}</div>
            <div class="form-group">
              <label class="form-label">{{ $lang.messages.account.email }}</label>
              <div class="text-bold text-md">{{ user.email }}</div>
            </div>
            <div class="form-group">
              <label class="form-label">{{ $lang.messages.account.name }}</label>
              <div class="text-bold text-md">{{ user.displayName }}</div>
            </div>
            <div class="form-group">
              <label class="form-label">{{ $lang.messages.account.new_name }}</label>
              <input id="parentName" type="text" maxlength="20"
                     :value="newName"
                     @input="validateAccountName($event.target.value)"
                     @blur="updateProfile"
                     @focus="$event.target.removeAttribute('readonly')"
                     autocorrect="off" spellcheck="false" autocomplete="off" readonly
                     :placeholder="$lang.messages.account.enter_name" class="form-control">
              <div class="form-error" v-if="changeNameError">{{ $lang.messages.account.name_error }}</div>
            </div>
            <div class="form-group">
              <label class="form-label">{{ $lang.messages.password }}</label>
              <div class="flex flex-column-xs mb-1">
                <InputPassword v-if="user && user.email"
                               value=""
                               class="mb-1-xs"
                               :customplaceholder="$lang.messages.account.enter_old_password"
                               @changepassword="oldPassword = $event"/>
                <InputPassword v-if="user && user.email"
                               value=""
                               class="ml-1 ml-0-xs"
                               :customplaceholder="$lang.messages.account.enter_new_password"
                               @changepassword="saveAccountPassword"/>
              </div>
              <button class="btn btn-main -shadow" @click="changeAccountPassword">{{ $lang.messages.account.change_password }}</button>
              <div v-if="accountPasswordMessage">
                <span class="form-success" v-if="accountPasswordMessage === 'Password changed'">
                  {{accountPasswordMessage}}
                </span>
                <span class="form-error" v-else>{{accountPasswordMessage}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="content-block-item device-setting" :class="{'device-setting-disabled': !accountData.isPremium}">
          <div class="device-setting-icon">
            <img src="../assets/img/account-parent.svg" alt="account">
          </div>
          <div class="device-setting-content">
            <div class="device-setting-title mb-1">{{ $lang.messages.account.additional_parent }}</div>
            <div class="form-group" v-if="!user.isLinked">
              <label class="form-label">{{ $lang.messages.account.email }}</label>
              <div class="flex">
                <input type="email" class="form-control" @keyup.enter="linkAccountWithEmail" v-model="linkedEmail" :placeholder="$lang.messages.account.additional_parent_placeholder">
                <button class="btn btn-main -shadow ml-1" @click="linkAccountWithEmail">{{ $lang.messages.account.sent_invite }}</button>
              </div>
              <div class="form-error" v-if="sendLinkRequestError">
                {{ sendLinkRequestError }}
              </div>
            </div>
            <div class="form-group" v-if="linkedAccounts">
              <div class="text-muted mb-1">{{ $lang.messages.account.parent_accounts }}</div>
              <div v-for="(value, name) in linkedAccounts" :key="name" class="flex-between flex-wrap flex-column-sm">
                <div class="flex-v-center mb-05 mb-xs-1">
                  <div class="account-settings-avatar mr-1"></div>
                  {{ value.linkedEmail }}
                  <div class="linked-account-status mobile-hidden">{{ value.status }}</div>
                </div>
                <div class="flex-between flex-v-center">
                  <div class="linked-account-status tablet-hidden">{{ value.status }}</div>
                  <button @click="unlinkAccount(name, true,value.status === 'approved')" class="linked-account-btn"> {{ $lang.messages.remove }} </button>
                </div>

              </div>
            </div>
            <div class="form-group" v-if="linkRequest && user.isLinked">
              <div class="text-muted mb-1">{{ $lang.messages.account.linked_account_text }}</div>
              <div class="flex-between flex-v-center flex-wrap flex-column-xs flex-align-start-xs">
                <div class="flex-v-center mr-1 mb-xs-1">
                  <div class="account-settings-avatar mr-1"></div>
                  {{linkRequest.mainAccountEmail}}
                </div>
                <div class="text-muted mr-1 mb-xs-1">
                  {{ $lang.messages.account.linked_account_description }}
                </div>
                <div class="mb-xs-1">
                  <button class="linked-account-btn" @click="unlinkAccount(user.uid, false, true)">
                    {{ $lang.messages.account.leave }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-block-item device-setting">
          <div class="device-setting-icon -highlight">
            <img src="../assets/img/locked-password-image.svg" alt="locked password">
          </div>
          <div class="device-setting-content">
            <div class="device-setting-title mb-1">{{ $lang.messages.account.password_dashboard }}</div>
            <label class="form-label">{{ $lang.messages.password }}</label>
            <InputPassword v-if="user && user.email"
                           passwordVisible="true"
                           :value="accountData.password"
                           :maxLength="4"
                           @changepassword="changeParentPassword"/>
            <div class="form-error" v-if="parentPasscodeError">{{ $lang.messages.account.password_error }}</div>
          </div>
        </div>
        <div class="content-block-item device-setting" v-if="!user.isLinked">
          <div class="device-setting-icon">
            <img src="../assets/img/gena-skate.svg" alt="subscription">
          </div>
          <div class="device-setting-content">
            <div class="device-setting-title mb-1">{{ $lang.messages.account.subscription_plan }}</div>
            <div class="subscription-list">
              <div class="subscription" v-if="!accountData.customer">
                <div class="subscription-info">
                  <div class="subscription-status">
                    <span class="subscription-status-label">{{ $lang.messages.account.status }}: </span>
                    <span class="subscription-status-info warning">{{ $lang.messages.account.no_subscription }}</span>
                  </div>
                </div>
              </div>
              <div v-if="subs">
                <div :key="item.id" v-for="(item, index) in subs" class="subscription"
                     v-show="item.status === 'active' || showAll || index === 0">
                  <div class="subscription-info">
                    <div class="subscription-status">
                      <span class="subscription-status-label">{{ $lang.messages.account.status }}: </span>
                      <span class="subscription-status-info" :class="item.status">{{ item.status }}</span>
                    </div>
                    <div class="text-lg text-bold">{{ item.plan.interval }} {{ $lang.messages.account.subscription }}</div>
                  </div>
                  <div class="subscription-period">
                    {{ $lang.messages.account.current_payment }}: {{ convertDate(item.current_period_start) }} - {{ convertDate(item.current_period_end) }} <br>
                  </div>
                  <div class="subscription-price text-lg text-bold">${{ item.plan.amount / 100 }}</div>
                  <button class="btn btn-secondary subscription-cancel" v-if="item.status === 'active' || item.status === 'trialing'"
                          v-on:click="cancel(item.id)">{{ $lang.messages.account.cancel_subscription }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="isAndroid">
              <a href="https://play.google.com/store/account/subscriptions" class="btn btn-main">Subscriptions</a>
            </div>
            <div v-else class="subscription-controls flex-v-center flex-between mt-1 flex-column-xs"
                 :class="{'flex-end': subs.some(item => item.status == 'active')}">
              <button v-if="!accountData.customer && !accountData.isPremium" class="btn btn-main mb-1-xs w-100-xs" @click="getPremium">
                {{ $lang.messages.get_premium_modal.title }}
              </button>
              <button v-if="accountData.customer && !subs.find(item => item.status === 'active') && !subs.find(item => item.status === 'trialing')"
                      @click="getPremium" class="btn btn-main w-100-xs">
                {{ $lang.messages.account.renew_subscription }}
              </button>
              <span v-if="subs" @click="showAll = !showAll"
                    class="text-bold pointer">{{ showAll ? $lang.messages.account.hide_history : $lang.messages.account.payments_history }}</span>
            </div>
          </div>
        </div>
        <div class="mt-2 text-md text-bold pointer" @click="out()">
          <i class="icon-logout"></i> {{ $lang.messages.sign_out }}
        </div>
      </div>
    </div>
    <PremiumPurchasedModal
        v-show="showPremiumIsPurchased"
        v-on:closemodal="showPremiumIsPurchased = false"/>
    <GetPremiumModal v-if="showGetPremium"
                     :customer="accountData.customer"
                     v-on:closepremiummodal="showGetPremium = false"
                     v-on:premiumispurchased="showPremiumIsPurchased = true"
                     v-on:updatesettings="saveAccountSettings"/>
    <GetPremiumModalAndroid v-if="showGetPremiumAndroid"
                            v-on:closepremiummodal="showGetPremiumAndroid = false" />
  </div>
</template>
<script>

import {reportEvent} from "@/helpers/utils";
import {mapGetters, mapState} from "vuex";
import InputPassword from "@/components/InputPassword";
import saveSetting from "@/components/mixins/saveSetting";
import Header from "@/components/Header";
import GetPremiumModalAndroid from "@/components/GetPremiumModalAndroid";
import GetPremiumModal from "@/components/GetPremiumModal";
import PremiumPurchasedModal from "@/components/PremiumPurchasedModal";
import firebase from "firebase/app";
import {getSubscriptions, cancelSubscription, getUserByEmail, removeActiveCampaignTag} from "@/helpers/api";
import {isFourDigit} from "@/helpers/utils";
import {db} from "@/fb/firebase";
import CONST from "../helpers/constants";
import {setClaim} from '../helpers/api'

const {LINKED_ACCOUNT_STATUSES, ACCOUNT_TYPES} = CONST;

export default {
  name: 'Account',
  mixins: [saveSetting],
  data() {
    return {
      showAll: false,
      subs: [],
      testPayment: localStorage.getItem('stripeTest'),
      accountPassword: null,
      accountPasswordMessage: null,
      showPremiumIsPurchased: false,
      showGetPremium: false,
      showGetPremiumAndroid: false,
      isAndroid: window.Android,
      oldPassword: '',
      newName: '',
      parentPasscodeError: false,
      changeNameError: false,
      linkedEmail: null,
      sendLinkRequestError: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountData: state => state.accountData,
      customer: state => state.accountData.customer,
      linkedData: state => state.linkedData,
    }),

    ...mapGetters({
      linkRequest: 'linkRequest'
    }),

    linkedAccounts() {
      return this.linkedData && this.linkedData[this.user.uid] && this.linkedData[this.user.uid].linkedEmails;
    },
  },
  watch: {
    customer: function () {
      this.getSubs()
    }
  },
  async mounted() {
    await this.getSubs();
  },
  methods: {
    async cancel(subscriptionId) {
      const cancelStatus = cancelSubscription(this.accountData.customer.id, subscriptionId, this.testPayment);
      if (cancelStatus) {
        this.saveAccountSettings(
            {
              isPremium: false
            }
        )
        await removeActiveCampaignTag({
          email: this.user.email,
          tag: 'monthlySubscription'
        })
        await removeActiveCampaignTag({
          email: this.user.email,
          tag: 'yearlySubscription'
        })
        reportEvent('cancelSubscription', {'email': this.user.email})
        await this.getSubs();
      }
    },
    async getSubs() {
      if (this.accountData.customer) {
        const subs = await getSubscriptions(this.accountData.customer.id, this.testPayment);
        this.subs = subs.subscriptions ? subs.subscriptions.data : [];
      }
    },
    convertDate(unix_timestamp) {
      const date = new Date(unix_timestamp * 1000);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getUTCFullYear();

      return day + '/' + month + '/' + year;
    },
    getPremium() {
      this.isAndroid ? this.showGetPremiumAndroid = true : this.showGetPremium = true
      reportEvent('premiumDialogOpen', {src: 'Account'})
    },
    changeParentPassword(value) {
      this.parentPasscodeError = false
      isFourDigit(value) ? this.saveAccountSettings({password: value}) : this.parentPasscodeError = true
    },
    changeAccountPassword() {
      const user = firebase.auth().currentUser;
      const oldPassword = this.oldPassword;

      const credentials = firebase.auth.EmailAuthProvider.credential(this.user.email, oldPassword);
      user.reauthenticateWithCredential(credentials)
        .then(() => {
          if (!this.accountPassword || this.accountPassword.length < 6) {
            this.accountPasswordMessage = 'Enter correct password (more than 6 characters)'
          } else {
            user.updatePassword(this.accountPassword).then(() => {
              this.accountPasswordMessage = null;
              this.accountPasswordMessage = 'Password changed';
            }).catch((error) => {
              this.accountPasswordMessage = error
            });
          }
        })
        .catch(error => this.accountPasswordMessage = error);
    },
    validateAccountName(value){
      if(value !== ' '){
        this.newName = value.trim()
      }
    },
    updateProfile() {
      if (this.newName && (this.newName.length > 2 && this.newName.length < 20 )) {
        const user = firebase.auth().currentUser;
        user.updateProfile({
          displayName: this.newName,
        }).then(() => {
          this.changeNameError = false;
          this.$store.commit('setUserName', this.newName)
          this.$dtoast.pop({
            preset: 'success',
            heading: 'The name was changed',
          });
        }, (error) => {
          this.$dtoast.pop({
            preset: 'error',
            heading: error,
          });
        });
      } else {
        this.changeNameError = true;
      }
    },
    saveAccountPassword(value){
      this.accountPassword = value
    },
    out() {
      firebase.auth().signOut();
      reportEvent('userSignOut')
    },
    validateEmail(){
      let isValid = true;
      let emailExists = false;
      let accountsKeys = this.linkedAccounts && Object.keys(this.linkedAccounts)
      if(accountsKeys){
        accountsKeys.some(key => {
          return emailExists = this.linkedAccounts[key].linkedEmail === this.linkedEmail && this.linkedAccounts[key].status !== 'rejected'
        })
      }

      if(this.linkedEmail === this.user.email){
        this.$dtoast.pop({
          preset: 'error',
          heading: "You can't sent invite to current email",
        });
        isValid  = false
      } else if(emailExists){
        this.$dtoast.pop({
          preset: 'error',
          heading: 'This email already linked',
        });
        isValid = false
      } else if(accountsKeys && accountsKeys.length > 3){
        this.$dtoast.pop({
          preset: 'error',
          heading: "You can't add more than 3 parent accounts to one email",
        });
        isValid = false
      } else if(!this.linkedEmail){
        this.$dtoast.pop({
          preset: 'error',
          heading: 'Enter email',
        });
        isValid = false
      }
      return isValid
    },
    linkAccountWithEmail() {
      this.sendLinkRequestError = null;
      if(this.validateEmail()){
        getUserByEmail(this.linkedEmail).then(res => {
          if (res.error) {
            this.sendLinkRequestError = res.error.message;
          } else {
            const accountBindingsRef = db.ref('accountBindings/' + this.user.uid);
            accountBindingsRef.child('mainAccountEmail').set(this.user.email);
            accountBindingsRef.child('linkedEmails/' + res.uid).set({
              linkedEmail: this.linkedEmail,
              status: LINKED_ACCOUNT_STATUSES.PENDING,
              show: true,
            });

            this.saveAccountSettings({
              accountType: ACCOUNT_TYPES.MAIN
            })
          }
        })
      }
    },
    unlinkAccount(unlinkUid, triggerFromMain = true, approvedStatus = false) {
      if (approvedStatus){
        setClaim({
          uid: unlinkUid,
          claim: {
            linkedUid: null,
          },
          refreshToken: true
        }).then(res => {
          if (res.ok) {
            this.$dtoast.pop({
              preset: 'success',
              heading: 'Account was unlinked',
            });
            if (triggerFromMain) {
              db.ref('accountBindings/' + this.user.uid + '/linkedEmails/' + unlinkUid).set(null);
            } else {
              db.ref('accountBindings/' + this.user.mainUid + '/linkedEmails/' + this.user.uid).set(null).then(() => {
                firebase.auth().currentUser.getIdToken(true).then(() => window.location.reload());
              });
            }
          }
        });
      } else {
        db.ref('accountBindings/' + this.user.uid + '/linkedEmails/' + unlinkUid).set(null);
      }

    }
  },
  components: {
    Header,
    InputPassword,
    PremiumPurchasedModal,
    GetPremiumModalAndroid,
    GetPremiumModal
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.subscription {
  display: flex;
  justify-content: space-between;
  padding: 18px 24px;

  @include responsive-below($sm){
    flex-direction: column;
    padding: 14px 0;
  }

  &-list {
    background: #F4F6F6;
    border-radius: 16px;
    position: relative;

    @include responsive-below($sm){
      background: transparent;
    }
  }

  &-period {
    display: flex;
    align-items: flex-end;
    font-size: 14px;
    color: #9797A0;
  }

  &-price {
    display: flex;
    align-items: flex-end;
  }

  &-controls {
    min-height: 52px;

    @include responsive-below($sm){
      min-height: 85px;
    }
  }

  &-cancel {
    position: absolute;
    bottom: -64px;
    left: 0;

    @include responsive-below($sm){
      left: calc(50% - 87px);
    }
  }

  &-status {
    font-size: 14px;

    &-label {
      color: #9797A0;
    }

    &-info {
      color: #ea2e22;
      padding: 18px 24px;

      &.active {
        color: #00c108;
      }

      &.warning {
        color: #d8ac27;
      }
    }
  }
}

.linked-account {

  &-status {
    background: #E0E6F3;
    border-radius: 60px;
    margin-left: 5px;
    font-size: 12px;
    padding: 3px 5px;
  }
  &-btn {
    color: #959595;
    background: none;
    border: 0;
    font-size: 16px;
    font-weight: 700;
    padding: 0;
    cursor: pointer;

    &:hover {
      color: #797777;
    }
  }
}
</style>
